(function () {
  if (window.__glsLB) return;
  window.__glsLB = true;

  var BIG = 1920, items = [], idx = 0, root, imgEl, counterEl;

  var CSS = ''
  + '.glsLB{position:fixed;inset:0;z-index:100000;display:none;align-items:center;justify-content:center;background:rgba(0,0,0,.91)}'
  + '.glsLB.is-open{display:flex}'
  + '.glsLB__bg{position:fixed;inset:0;background:rgba(0,0,0,.92);opacity:1;z-index:1}'
  + '.glsLB.is-in .glsLB__bg{opacity:1}'
  + '.glsLB__stage{position:relative;z-index:2;width:100%;height:100%;display:flex;align-items:center;justify-content:center;padding:5vh 9vw}'
     + '.glsLB__img{max-width:100%;height:70vh;object-fit:contain;opacity:0;transform:scale(.88);transition:opacity .55s ease,transform .6s cubic-bezier(.2,.8,.2,1);border-radius:4px}'
  + '.glsLB.is-in .glsLB__img{opacity:1;transform:scale(1)}'
  + '.glsLB__nav,.glsLB__close{position:absolute;z-index:3;border:0;cursor:pointer;display:flex;align-items:center;justify-content:center;background:rgba(255,255,255,.92);color:#000;border-radius:50%;transition:background .2s,transform .2s}'
  + '.glsLB__nav:hover,.glsLB__close:hover{background:#fff;transform:scale(1.07)}'
  + '.glsLB__nav{top:50%;margin-top:-27px;width:54px;height:54px}'
  + '.glsLB__prev{left:4vw}.glsLB__next{right:4vw}'
  + '.glsLB__close{top:4rem;right:5rem;width:44px;height:44px}'
  + '.glsLB__counter{position:absolute;top:2.9rem;left:4vw;z-index:3;color:#fff;font-size:1.4rem;letter-spacing:.05em}'
  + 'body.glsLB-lock{overflow:hidden}'
  + '@media(max-width:749px){.glsLB__stage{padding:8vh 4vw}.glsLB__nav{width:44px;height:44px;margin-top:-22px}'
  + '.glsLB__prev{left:2vw}.glsLB__next{right:2vw}.glsLB__close{top:1.2rem;right:1.2rem}.glsLB__counter{top:1.7rem;left:1.5rem}}';

  function svg(d){return '<svg viewBox="0 0 24 24" width="26" height="26" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="'+d+'"/></svg>';}

  function upsize(s){try{var u=new URL(s,location.href);u.searchParams.set('width',BIG);return u.href;}catch(e){return s;}}

  function collect(){
    var l=document.querySelector('.product__media-list'); if(!l) return [];
    var out=[];
    l.querySelectorAll('.product__media-item').forEach(function(li){
      var im=li.querySelector('img'); if(!im) return;
      out.push({src:upsize(im.currentSrc||im.src),alt:im.alt||'',id:li.getAttribute('data-media-id')||''});
    });
    return out;
  }

  function build(){
    var st=document.createElement('style'); st.textContent=CSS; document.head.appendChild(st);
    root=document.createElement('div'); root.className='glsLB';
    root.innerHTML='<div class="glsLB__bg"></div><div class="glsLB__counter"></div>'
      +'<button type="button" class="glsLB__close" aria-label="Close">'+svg('M6 6l12 12M18 6L6 18')+'</button>'
      +'<button type="button" class="glsLB__nav glsLB__prev" aria-label="Previous">'+svg('M15 5l-7 7 7 7')+'</button>'
      +'<button type="button" class="glsLB__nav glsLB__next" aria-label="Next">'+svg('M9 5l7 7-7 7')+'</button>'
      +'<div class="glsLB__stage"><img class="glsLB__img" alt=""></div>';
    document.body.appendChild(root);
    imgEl=root.querySelector('.glsLB__img');
    counterEl=root.querySelector('.glsLB__counter');
    root.querySelector('.glsLB__close').addEventListener('click',close);
    root.addEventListener('click',function(e){if(!e.target.closest('.glsLB__img')&&!e.target.closest('.glsLB__nav')&&!e.target.closest('.glsLB__close'))close();});
    root.querySelector('.glsLB__prev').addEventListener('click',function(e){e.stopPropagation();step(-1);});
    root.querySelector('.glsLB__next').addEventListener('click',function(e){e.stopPropagation();step(1);});
    var tx=0;
    root.addEventListener('touchstart',function(e){tx=e.touches[0].clientX;},{passive:true});
    root.addEventListener('touchend',function(e){var d=e.changedTouches[0].clientX-tx;if(Math.abs(d)>50)step(d<0?1:-1);});
    document.addEventListener('keydown',function(e){
      if(!root.classList.contains('is-open'))return;
      if(e.key==='Escape')close();
      if(e.key==='ArrowLeft')step(-1);
      if(e.key==='ArrowRight')step(1);
    });
  }

  function render(){
    var it=items[idx]; if(!it)return;
    imgEl.src=it.src; imgEl.alt=it.alt;
    counterEl.textContent=(idx+1)+' / '+items.length;
    var multi=items.length>1;
    root.querySelector('.glsLB__prev').style.display=multi?'flex':'none';
    root.querySelector('.glsLB__next').style.display=multi?'flex':'none';
    counterEl.style.display=multi?'block':'none';
  }

  function step(d){idx=(idx+d+items.length)%items.length;render();}

  function open(i){
    if(!root)build();
    idx=i; render();
    root.classList.add('is-open');
    document.body.classList.add('glsLB-lock');
    requestAnimationFrame(function(){root.classList.add('is-in');});
  }

  function close(){
    root.classList.remove('is-in');
    document.body.classList.remove('glsLB-lock');
    setTimeout(function(){root.classList.remove('is-open');},500);
  }

  document.addEventListener('click',function(e){
    var t=e.target.closest && e.target.closest('.product__media-toggle');
    if(!t)return;
    var li=t.closest('.product__media-item'); if(!li)return;
    e.preventDefault(); e.stopPropagation();
    if(e.stopImmediatePropagation)e.stopImmediatePropagation();
    items=collect(); if(!items.length)return;
    var id=li.getAttribute('data-media-id');
    var i=-1;
    for(var k=0;k<items.length;k++){if(items[k].id===id){i=k;break;}}
    open(i<0?0:i);
  },true);
})();